import React, { Component } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import { getAllContent } from '../Actions/content'
import Colors from '../Styles/Colors';
import Fonts from '../Styles/Fonts';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'RosVar';
    src: url('/_assets/fonts/RoslindaleVariableDisplay-VF.woff2'),
        url('/_assets/fonts/RoslindaleVariableDisplay-VF.woff');
    font-style: normal;
    font-weight: normal;
  }

  div {
    box-sizing: border-box;
  }

  body {
    ${Fonts.spectral.regular};
    font-size: 16px;
    color: ${Colors.black};
    overflow: hidden;
  }

  a {
    color: ${Colors.blue};
    text-decoration: none;
  }
`;
const Container = styled.div`
    background-color: ${Colors.black};
    width: 100vw;
    height: 100vh;
    max-width: 640px;
    margin: auto;
    display: flex;
    flex-direction: column;
    position: relative;
`;
const Loader = styled.div`
  ${Fonts.roslindale.medium};
  font-size: 28px;
  color: ${Colors.white};
  background-color: ${Colors.black};
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
`;

class SiteContainer extends Component {
  componentDidMount = () => {
    this.props.performDispatch(getAllContent());
  };

  render() {
    return (
      <Container>
        <GlobalStyle />
        { this.props.isLoading &&
          <Loader>Loading...</Loader>
        }
        { this.props.isLoading === false &&
          this.props.children
        }
      </Container>
      
    );
  }
}

const mapStateToProps = (state) => {
  return {
      isLoading: state.content.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      performDispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteContainer);